import { useCallback, useEffect, useRef, useState } from "react";
import { useWebSocketContext } from "../contexts/WebSocketProvider";

export default function useResetStation() {
  const { send, isConnected, isOpen, connect } = useWebSocketContext();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const mountedRef = useRef(true);
  const connectionAttemptedRef = useRef(false);

  const resetStation = useCallback(
    async ({ stationId }) => {
      if (!mountedRef.current) return;

      setIsLoading(true);
      setError("");

      try {
        // Ensure WS connection is alive
        if (!isConnected) {
          if (!connectionAttemptedRef.current) {
            connectionAttemptedRef.current = true;
            await connect();
          }

          // Same 10s timeout logic as your login hook
          await new Promise((resolve, reject) => {
            const start = Date.now();
            const interval = setInterval(() => {
              if (!mountedRef.current) {
                clearInterval(interval);
                reject(new Error("Component unmounted"));
              } else if (isOpen()) {
                clearInterval(interval);
                resolve(true);
              } else if (Date.now() - start > 10000) {
                clearInterval(interval);
                reject(new Error("WebSocket connection timeout"));
              }
            }, 100);
          });
        }

        // Flutter payload
        const request = {
          type: "send_command",
          payload: {
            command: "full_reset",
            station_id: stationId,
            gun_id: "yin",
          },
        };

        console.log("Sending reset station:", request);

        const response = await send("send_command", request);
        console.log("Reset Station Response:", response);

        return { success: true, response };
      } catch (err) {
        setError(err.message);
        return { success: false, error: err.message };
      } finally {
        if (mountedRef.current) setIsLoading(false);
      }
    },
    [isConnected, isOpen, connect, send]
  );

  // Mounted safety
  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);

  return {
    resetStation,
    isLoading,
    error,
  };
}
